import { animate } from 'motion';

(function () {
	const hiringButton = document.querySelector('.hiring');

	if (!hiringButton) return;

	const hiringIcon = hiringButton.querySelector('.hiring__icon');
	const hiringText = hiringButton.querySelector('.hiring__text');

	if (!hiringIcon || !hiringText) return;

	const SCROLL_THRESHOLD = 300;
	let textHasAnimated = false;

	// Text is hidden initially (icon starts hidden via CSS)
	hiringText.style.transform = 'scale(0)';
	hiringText.style.opacity = '0';

	// Animate icon on page load
	function animateIconOnLoad() {
		animate(
			hiringIcon,
			{
				scale: [0, 1.1, 1],
			},
			{
				duration: 0.5,
				easing: [0.34, 1.56, 0.64, 1], // easeOutBack for bounce effect
			}
		);

	}

	// Animate icon immediately when DOM is ready
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', animateIconOnLoad);
	} else {
		// DOM already loaded, animate immediately
		setTimeout(animateIconOnLoad, 100);
	}

	function handleScroll() {
		const scrollY = window.scrollY || document.documentElement.scrollTop;

		if (scrollY >= SCROLL_THRESHOLD && !textHasAnimated) {
			textHasAnimated = true;

			// Animate text with slight delay and scale
			animate(
				hiringText,
				{
					scale: [0, 1.05, 1],
					opacity: [0, 1],
				},
				{
					duration: 0.5,
					delay: 0.1,
					easing: [0.34, 1.56, 0.64, 1], // easeOutBack for bounce effect
				}
			);
		} else if (scrollY < SCROLL_THRESHOLD && textHasAnimated) {
			textHasAnimated = false;

			// Only hide text when scrolling back up, icon stays visible
			animate(
				hiringText,
				{
					scale: [1, 0],
					opacity: [1, 0],
				},
				{
					duration: 0.3,
					easing: [0.16, 1],
				}
			).then(() => {
				// Ensure text stays hidden after animation
				hiringText.style.transform = 'scale(0)';
				hiringText.style.opacity = '0';
			});
		}
	}

	// Check initial scroll position
	handleScroll();

	// Listen to scroll events
	let scrolling = false;
	window.addEventListener('scroll', function () {
		if (!scrolling) {
			scrolling = true;
			window.requestAnimationFrame
				? window.requestAnimationFrame(function () {
						handleScroll();
						scrolling = false;
				  })
				: setTimeout(function () {
						handleScroll();
						scrolling = false;
				  }, 16);
		}
	});
})();

